export default "__VITE_ASSET__DE3lD$Di__"